import { Col, Row } from 'reactstrap';
import { useFormState } from 'utils/hooks';
import { FormState } from 'common/entities/form/FormTypes';

import Input from 'common/components/form/inputs/Input';
import Checkbox from 'common/components/form/inputs/Checkbox';
import Switch from 'common/components/form/inputs/Switch';
import ColorSelect from 'common/components/findings/form/ColorSelect';

const Edit = ({ formState }) => {
  const { fields, changeField, selectField } = useFormState(formState);

  return (
    <Row className="no-gutters">
      <Col xs={12}>
        <Input
          label="Name"
          onChange={changeField('name')}
          placeholder="Add name"
          {...fields.name}
        />
      </Col>

      <Col xs={12}>
        <Input
          label="label"
          onChange={changeField('label')}
          placeholder="Add label"
          {...fields.label}
        />
      </Col>

      <Col xs={12}>
        <Checkbox
          label="Show on Performance Reports"
          value={fields.for_performance_reports?.value}
          onChange={() =>
            selectField('for_performance_reports')(!fields.for_performance_reports?.value)
          }
          className="text-primary"
        />
      </Col>
      <Col xs={12}>
        <ColorSelect
          label="Color"
          type="event"
          onChange={color => selectField('color')(color)}
          optionsLength={28}
          {...fields.color}
        />
      </Col>
      <Col xs={12}>
        <Switch
          onChange={() => selectField('active')(fields.active?.value ? false : true)}
          className="d-flex align-items-start mb-0"
          size="md"
          switchClassName="d-flex flex-column"
          labelClassName="cmb-4"
          label="Status"
          innerOnLabel="ON"
          innerOffLabel="OFF"
          {...fields.active}
        />
      </Col>
    </Row>
  );
};

Edit.propTypes = {
  formState: FormState
};

export default Edit;
